//手机
function validMobile(mobile){
 	var mobileReg =  /^1[345789]\d{9}$/;
 	if( mobileReg.test(mobile) ){
     	return true;
 	}
 	return false;
}

// 验证固定电话, true - 合法, false - 不合法
function validTelephone(telephone){
 	var telephoneReg = /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;	// 010-60605232-2468, 0271-6541234
 	var telephoneReg = /^0\d{2,3}-?\d{7,8}$/;
 	if( telephoneReg.test(telephone) ){
     	return true;
 	}
 	return false;
}

//密码
function validPassword(password){
  var reg=/^(?![^a-zA-Z]+$)(?!\D+$).{8,16}$/;
   if(reg.test(password)){
     return true;
  }
  return false;
}

//scc
function validScc(scc){
  var reg =/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;
  if(reg.test(scc)){
     return true;
  }
  return false;
}

function validIDcard(id){
  var reg =  /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  if(reg.test(id)){
     return true;
  }
  return false;
}

/* 是否固话*/
function validateTelphone(value) {
  const reg = /^((0\d{2,3}-?\d{7,8})|([48]00-?[0-9]{4}-?[0-9]{3}))$/
  if(reg.test(value)){
     return true;
  }
  return false;
}

export {
    validMobile,
    validTelephone,
    validPassword,
    validScc,
    validIDcard,
    validateTelphone
}
